import { LANGUAGE_STORAGE_KEY } from 'core/axios/interceptors/addLanguageInterceptor';

// eslint-disable-next-line import/prefer-default-export
export const getSelectedLanguage = () => {
  try {
    return localStorage.getItem(LANGUAGE_STORAGE_KEY) || 'en';
  } catch {
    return 'en';
  }
};
